import { SelectedKontakt } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_KONTAKT_ANGABE = 'KONTAKT-ANGABE';

export enum SelectedKontaktTyp {
  Mobile = 'MOBILE',
  Email = 'EMAIL',
}

export interface KontaktAngabeModelConfig extends DynamicFormValueControlModelConfig<SelectedKontakt> {
  kunden?: SelectedKontakt[];
  noContactMessage?: string;
  noContactCheckboxLabel?: string;
}

export class KontaktAngabeModel extends DynamicFormValueControlModel<SelectedKontakt> {
  @serializable() readonly type: string = TYPE_KONTAKT_ANGABE;
  @serializable() kunden: SelectedKontakt[] | null;
  @serializable() noContactMessage: string | null;
  @serializable() noContactCheckboxLabel: string | null;

  constructor(config: KontaktAngabeModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.kunden = config.kunden || null;
    this.noContactMessage = config.noContactMessage || null;
    this.noContactCheckboxLabel = config.noContactCheckboxLabel || null;
  }
}
